// extracted by mini-css-extract-plugin
export var school = "style-module--school--16z9h";
export var logoContainer = "style-module--logoContainer--3eVbE";